<template>
    <prompt v-else
        :title="title"
        :body="body"
        icon="fa fa-trash"
        :buttons="[{ 
                    name: resource('Button_No'), 
                    class: 'btn btn-secondary btn-sm',
                    emit: 'no',
                    icon: 'fa fa-times'
                }, { 
                    name: resource('Button_Yes'), 
                    class: 'btn btn-primary btn-sm',
                    emit: 'yes',
                    icon: 'fas fa-check'
                }]"

        @yes="confirm"
        @hidden="onHidden"
    >
        <template #body>
            <div class="row form-group">
                <div class="col-12">
                    <p>
                        {{body}}
                    </p>
                </div>
            </div>
            
            <div class="row form-group" v-if="displayCommentPrompt">
                <div class="col-12">
                    <label for="removalComment">{{resource('JourneyComposer_BrickSettingsBase_Comment_Label')}}</label>
                </div>
                <div class="col-12">
                    <comment-editor v-model="comment" id="removalComment" />
                </div>
            </div>
        </template>
    </prompt>
</template>

<script>
import {createNamespacedHelpers} from 'vuex';
import {brickDefinitions} from "@modules/JourneyBuilder/Bricks/brick-definitions";

import resources from "@core/Util/Mixins/resources";

import Prompt from "@core/Components/Util/Prompt";
import {CommentEditor} from "@modules/JourneyBuilder/Components/Composer/CanvasArea/Bricks/Comments";

const {mapState, mapMutations} = createNamespacedHelpers('journeyBuilder/composer');

export default {
    name: "DeleteBrickPrompt",
    mixins: [resources],
    components: {
        Prompt,
        CommentEditor
    },
    methods: {
        ...mapMutations(['setNewComment']),
        confirm(){
            //Even if no comment was allowed; undo the previous comment
            //the brick has been deleted, a regular modification comment should thus not be preserved
            //this to avoid confusion
            this.setNewComment({ brickId: this.brickId, content: this.comment });

            this.$emit('yes');
        },
        onHidden(){
            this.$emit('hidden');
        }
    },
    computed: {
        ...mapState(['brickMap']),
        displayCommentPrompt(){
            const brick = this.brickMap[this.brickId];
            
            //New bricks shouldn't require a comment upon removing
            return !brick.isNew && 
                brickDefinitions[brick.type].supportsComments;
        }
    },
    props: {
        brickId: {
            type: String,
            required: true
        },
        title: {
            type: String,
            required: true
        },
        body: {
            type: String,
            required: true
        }
    },
    data(){
        return {
            comment: ''
        }
    }
}
</script>
